"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrap = exports.WrappedPropertyCtor = exports.WrappedPropertyBoolean = exports.WrappedPropertyString = exports.WrappedPropertyNumber = exports.WrappedPropertyObject = exports.WrappedPropertyArray = void 0;
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
exports.WrappedPropertyCtor = WrappedPropertyCtor_1.default;
var WrappedPropertyArray_1 = require("./WrappedPropertyArray");
exports.WrappedPropertyArray = WrappedPropertyArray_1.default;
var WrappedPropertyObject_1 = require("./WrappedPropertyObject");
exports.WrappedPropertyObject = WrappedPropertyObject_1.default;
var WrappedPropertyNumber_1 = require("./WrappedPropertyNumber");
exports.WrappedPropertyNumber = WrappedPropertyNumber_1.default;
var WrappedPropertyString_1 = require("./WrappedPropertyString");
exports.WrappedPropertyString = WrappedPropertyString_1.default;
var WrappedPropertyBoolean_1 = require("./WrappedPropertyBoolean");
exports.WrappedPropertyBoolean = WrappedPropertyBoolean_1.default;
var IOptions_1 = require("./IOptions");
var fixAndMergeSchema_1 = require("../JSchema/fixAndMergeSchema");
var fixData_1 = require("../JSchema/fixData");
function wrap(parent, schema, propName, options) {
    // console.log('wrap');
    // napraw schema, rozwią refs i dodaj $parent
    var stime = new Date().getTime();
    // console.log('fixSchema', new Date().getTime() - stime);
    // czy schema było naprawioane czy nie
    if (Array.isArray(schema)) {
        schema = (0, fixAndMergeSchema_1.default)(schema);
    }
    else if (schema.$parent === undefined) {
        schema = (0, fixAndMergeSchema_1.default)([schema]);
    }
    // this.calcFunctions = [];
    // this.summaryFunctions = [];
    var mainprop;
    var opts = (0, IOptions_1.fixSchemaOptions)(options);
    if (propName) {
        if (parent[propName].__ob__ === undefined && opts.Vue) {
            opts.Vue.observable(parent.propName);
        }
        if (opts.fixData) {
            (0, fixData_1.default)(schema, parent.propName, opts.Vue, false);
        }
        mainprop = new WrappedPropertyObject_1.default(null, parent, propName, schema, opts);
    }
    else {
        var data = { model: parent };
        if (data.model.__ob__ === undefined && opts.Vue) {
            opts.Vue.observable(data.model);
        }
        if (opts.fixData) {
            (0, fixData_1.default)(schema, data.model, opts.Vue, false);
        }
        mainprop = new WrappedPropertyObject_1.default(null, data, 'model', schema, opts);
    }
    Object.seal(mainprop);
    return mainprop;
}
exports.wrap = wrap;
exports.default = WrappedPropertyCtor_1.default;
//# sourceMappingURL=index.js.map